import { useEffect } from 'react';

import ResizeObserver from 'resize-observer-polyfill';

const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.contentRect) {
      const { height } = entry.contentRect;
      window.parent.postMessage(
        {
          frameHeight: height,
        },
        '*'
      );
    }
  });
});

export const useIFrameHeight = (containerId: string, enabled: boolean): void => {
  useEffect(() => {
    const container = document.querySelector(`#${containerId}`);
    if (enabled && container) {
      resizeObserver.observe(container);
    }

    return () => {
      if (container) {
        resizeObserver.unobserve(container);
      }
    };
  }, [containerId, enabled]);
};
